import { Box, Button, Stack } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";

import AddVideoForm from "./form";
import { IVideoCreateFormType } from "./type";

import DashboardContent from "@/components/app/DashboardContent";
import DashboardHeader from "@/components/app/DashboardHeader";
import ROUTE_CONSTANTS from "@/constants/route-constants";
import { useCheckPermissionAccess } from "@/hooks/useCheckPermissionAccess";
import { videoService } from "@/api/services/video";
import { getAxiosError } from "@/utils/get-axios-error";
import { OperationAccess, PagesAccess } from "@/constants/enums/permissions";

export default function AddVideo() {
    const [loading, setSubmitLoading] = useState(false);
    const navigate = useNavigate();
    const listAccess = useCheckPermissionAccess(PagesAccess.VIDEO, OperationAccess.LIST);

    const handleSubmit = async (_val: IVideoCreateFormType) => {
        try {
            setSubmitLoading(true);
            await videoService.create(_val);
            enqueueSnackbar(`Video created successfully`, { variant: "success" });
            navigate(ROUTE_CONSTANTS.MEDIA_MANAGEMENT.VIDEOS.ROOT.ABSOLUTE);
        } catch (err) {
            const error = getAxiosError(err);
            const message = error?.meta.message || "Server Error";

            enqueueSnackbar(message, { variant: "error" });
        } finally {
            setSubmitLoading(false);
        }
    };

    return (
        <>
            <DashboardHeader
                title="Create Video"
                {...(listAccess
                    ? {
                          titleSuffix: (
                              <Stack direction={"row"} spacing={2}>
                                  <Button component={Link} to={ROUTE_CONSTANTS.MEDIA_MANAGEMENT.VIDEOS.ROOT.ABSOLUTE}>
                                      Back To Video List
                                  </Button>
                              </Stack>
                          ),
                      }
                    : undefined)}
            />
            <DashboardContent>
                <Box sx={{ margin: "0 auto", maxWidth: "500px" }}>
                    <AddVideoForm loading={loading} onSubmit={handleSubmit} />
                </Box>
            </DashboardContent>
        </>
    );
}
